module.exports = "<p>json-diff works!</p>\n";